
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  brandLogo,
  brandMark,
  brandName,
  isWhitelabel,
  OPERATING_ENTITY,
} from '@/utils/brand';

export interface ITocItem {
  id: string;
  title: string;
}

@Component({
  name: 'LegalLayout',
})
export default class LegalLayout extends Vue {
  /* brand mark and name, overridable per whitelabel from build-time env */
  get brandLogo(): string {
    return brandLogo();
  }

  get brandName(): string {
    return brandName();
  }

  get brandMark(): string {
    return brandMark();
  }

  get isWhitelabel(): boolean {
    return isWhitelabel();
  }

  get operatingEntity(): string {
    return OPERATING_ENTITY;
  }
  @Prop({ default: 'Legal' }) label!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ default: '' }) lead!: string;
  @Prop({ default: () => [] }) toc!: ITocItem[];

  get year(): number {
    return new Date().getFullYear();
  }

  scrollTo(id: string): void {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
